/**
 * Timekeeper constants
 */

const UPDATE_TIME = 'redux-timekeeper/UPDATE_TIME';
export default UPDATE_TIME;
